import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Translation } from 'react-i18next';
import FormText from '../../components/FormText';
import FormDatePicker from '../../components/FormDatePicker';
import FormSelect from '../../components/FormSelect';
import {
  object,
  string,
  func,
  arrayOf,
  bool,
  shape,
  any,
  number,
} from 'prop-types';

const styles = (theme) => ({
  component: {
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  barLayout: {
    padding: theme.spacing(1),
  },
  subPage: {
    marginTop: theme.spacing(2),
  },
});

const PassportDetailsComponent = ({
  classes,
  passportNumber,
  passportNumberError,
  isPassportNumberRequired,
  placeOfIssue,
  placeOfIssueError,
  isPlaceOfIssueRequired,
  expiryDate,
  expiryDateError,
  isExpiryDateRequired,
  issueDate,
  issueDateError,
  isIssueDateRequired,
  passportType,
  passportTypeError,
  isPassportTypeRequired,
  passportTypes,
  passportNumberChanged,
  placeOfIssueChanged,
  expiryDateChanged,
  issueDateChanged,
  passportTypeChanged,
  portOfEntry,
  portOfEntryError,
  isPortOfEntryRequired,
  date,
  dateError,
  isDateRequired,
  stayLength,
  stayLengthError,
  isStayLengthRequired,
  stayLengths,
  destinations,
  destinationsError,
  isDestinationsRequired,
  transportationMode,
  transportationModeError,
  isTransportationModeRequired,
  transportationModes,
  portOfEntryChanged,
  portOfEntryOptions,
  dateChanged,
  stayLengthChanged,
  destinationsChanged,
  transportationModeChanged,
  destAddress,
  destAddressError,
  isDestAddressRequired,
  destAddressChanged,
  destAddressOptions,
  targetCountryName,
  readOnly = false,
}) => (
  <Translation>
    {(t) => {
      return (
        <div>
          <Typography
            className={classes.barLayout}
            style={{ color: '#ffffff', background: '#4CAF50' }}
            variant="subtitle1"
            align="left"
            gutterBottom
          >
            {t('passportDetails')}
          </Typography>
          <Grid container spacing={3} key="form-grid-container">
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="passport-number"
                label={t('passportNumber2')}
                value={passportNumber}
                onChange={passportNumberChanged}
                readOnly={readOnly}
                tooltip=""
                required={isPassportNumberRequired}
                error={passportNumberError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="place-of-issue"
                label={t('placeIssue')}
                value={placeOfIssue}
                onChange={placeOfIssueChanged}
                readOnly={readOnly}
                tooltip=""
                required={isPlaceOfIssueRequired}
                error={placeOfIssueError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="passportType"
                label={t('passportType')}
                value={passportType}
                options={passportTypes}
                onChange={passportTypeChanged}
                readOnly={readOnly}
                required={isPassportTypeRequired}
                error={passportTypeError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormDatePicker
                className={classes.component}
                label={t('passportExpiry')}
                id="expiry-date"
                value={expiryDate}
                onChange={expiryDateChanged}
                readOnly={readOnly}
                required={isExpiryDateRequired}
                error={expiryDateError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormDatePicker
                className={classes.component}
                label={t('passportIssue')}
                id="issue-date"
                value={issueDate}
                onChange={issueDateChanged}
                readOnly={readOnly}
                required={isIssueDateRequired}
                error={issueDateError}
              />
            </Grid>
          </Grid>
          <div className={classes.subPage} />
          <Typography
            className={classes.barLayout}
            style={{ color: '#ffffff', background: '#4CAF50' }}
            variant="subtitle1"
            align="left"
            gutterBottom
          >
            {t('travelDetails')}
          </Typography>
          <Grid
            container
            spacing={3}
            alignItems="flex-end"
            key="form-grid-container2"
          >
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="port-of-entry"
                label={t('portEntry')}
                value={portOfEntry}
                options={portOfEntryOptions}
                onChange={portOfEntryChanged}
                readOnly={readOnly}
                tooltip=""
                required={isPortOfEntryRequired}
                error={portOfEntryError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormDatePicker
                className={classes.component}
                label={t('intendedDate')}
                id="date"
                value={date}
                onChange={dateChanged}
                readOnly={readOnly}
                required={isDateRequired}
                error={dateError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                type='number'
                className={classes.component}
                id="lengthOfStay"
                label={t('maximumStay')}
                value={stayLength}
                options={stayLengths}
                onChange={stayLengthChanged}
                readOnly={readOnly}
                required={isStayLengthRequired}
                error={stayLengthError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="destAddress"
                label={`${t('nameAndNumberIn')} ${targetCountryName}`}
                value={destAddress}
                onChange={destAddressChanged}
                readOnly={readOnly}
                tooltip=""
                required={isDestAddressRequired}
                error={destAddressError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="transportation-mode"
                label={t('modesTransport')}
                value={transportationMode}
                options={transportationModes}
                onChange={transportationModeChanged}
                readOnly={readOnly}
                required={isTransportationModeRequired}
                error={transportationModeError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="destination"
                label={t('destinations')}
                value={destinations}
                options={destAddressOptions}
                onChange={destinationsChanged}
                readOnly={readOnly}
                tooltip=""
                required={isDestinationsRequired}
                error={destinationsError}
              />
            </Grid>
          </Grid>
        </div>
      );
    }}
  </Translation>
);

PassportDetailsComponent.propTypes = {
  classes: object.isRequired,
  passportNumber: string,
  passportNumberError: string,
  isPassportNumberRequired: bool,
  placeOfIssue: string,
  placeOfIssueError: string,
  isPlaceOfIssueRequired: bool,
  expiryDate: string,
  expiryDateError: string,
  isExpiryDateRequired: bool,
  issueDate: string,
  issueDateError: string,
  isIssueDateRequired: bool,
  passportType: string,
  passportTypeError: string,
  isPassportTypeRequired: bool,
  passportTypes: arrayOf(
    shape({
      label: any,
      value: any,
    })
  ),
  passportNumberChanged: func.isRequired,
  placeOfIssueChanged: func.isRequired,
  expiryDateChanged: func.isRequired,
  issueDateChanged: func.isRequired,
  passportTypeChanged: func.isRequired,
  portOfEntry: string,
  portOfEntryError: string,
  isPortOfEntryRequired: bool,
  date: string,
  dateError: string,
  isDateRequired: bool,
  stayLength: number,
  stayLengthError: string,
  isStayLengthRequired: bool,
  stayLengths: arrayOf(any),
  destinations: string,
  destinationsError: string,
  isDestinationsRequired: bool,
  transportationMode: string,
  transportationModeError: string,
  isTransportationModeRequired: bool,
  transportationModes: arrayOf(any),
  portOfEntryChanged: func.isRequired,
  dateChanged: func.isRequired,
  stayLengthChanged: func.isRequired,
  destinationsChanged: func.isRequired,
  transportationModeChanged: func.isRequired,
  destAddress: string,
  destAddressError: string,
  isDestAddressRequired: bool,
  destAddressChanged: func.isRequired,
  targetCountryName: string.isRequired,
};

export default withStyles(styles)(PassportDetailsComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/PassportDetails/PassportDetailsComponent.js